module.exports = __webpack_public_path__ + "img/01.5a7391e8.jpg";